import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideStore } from '@ngrx/store';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {AuthGuard} from "../guards/auth.guard";
import {GuestGuard} from "../guards/guest.guard";
import {AuthService} from "../services/auth.service";
import {HttpClientModule} from "@angular/common/http";
import {provideToastr} from "ngx-toastr";

export const appConfig: ApplicationConfig = {

  providers: [
    provideRouter(routes), provideStore(), provideAnimationsAsync(), provideToastr(),
    AuthGuard, GuestGuard,
  ]
};
